export const environment = {
  production: true,
  apiUrl:"https://api.prod.sip.stulzindia.co.in/"
};
